// extracted by mini-css-extract-plugin
export default {"container":"Learning_page_container__qB7IH"};